import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import CustomTypography from "./CustomTypography";
import theme from "../../assets/theme";

const StyledSelect = ({
  label,
  value,
  onChange,
  options = [],
  disabled,
  required = false,
  shrink = true,
  ...props
}) => {
  const selectStyle = {
    borderRadius: theme.borderRadius.medium,
    backgroundColor: disabled
      ? theme.palette.lightgray.light
      : theme.palette.lightgray.main,
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.gray.main,
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: disabled
        ? theme.palette.gray.main
        : theme.palette.primary.main,
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: disabled
        ? theme.palette.gray.main
        : theme.palette.primary.main,
    },
    mt:-2
  };

  return (
    <Box sx={{ width: "100%" }}>
      {label && (
        <CustomTypography
          variant="bodyText1"
          display="block"
          gutterBottom
          color="dark.main"
        >
          {label} {required && "*"}
        </CustomTypography>
      )}
      <FormControl fullWidth size="small" disabled={disabled} margin="normal">
        <Select
          value={value}
          onChange={onChange}
          displayEmpty
          sx={selectStyle}
          notched
          {...props}
        >
          {options.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default StyledSelect;
